module.exports = __webpack_public_path__ + "assets/img/Catalogs.4771fa87.svg";